"use client";
import React from "react";
import Link from "next/link";
import Image from "next/image";
import { useRouter } from "next/router";

const FooterModern = ({ onGetDemo }) => {
  const currentYear = new Date().getFullYear();
  const router = useRouter();

  const handleAboutClick = (e) => {
    e.preventDefault();
    if (router.pathname === "/" || router.pathname === "/home/home_1") {
      const element = document.getElementById('about-section');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } else {
      router.push("/#about-section");
    }
  };

  const footerLinks = {
    company: [
      { name: "About", href: "#", onClick: handleAboutClick },
      { name: "Contact", href: "#", onClick: () => onGetDemo && onGetDemo() }
    ],
    legal: [
      { name: "Privacy Policy", href: "/privacy-policy" },
      { name: "Terms of Service", href: "/terms-of-service" },
      { name: "Cookie Policy", href: "/cookie-policy" }
    ]
  };

  return (
    <footer className="relative bg-[#F3F1FA] border-t border-accent/10">
      {/* Main footer content */}
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand column */}
          <div className="lg:col-span-2">
            <Link href="/">
              <a className="inline-block">
                <img
                  src="/images/logo.png"
                  className="max-h-12"
                  alt="SynthiaHire"
                />
              </a>
            </Link>
            <p className="mt-4 text-jacarta-500 text-sm leading-relaxed max-w-sm">
              AI-powered recruitment platform transforming BFSI hiring with intelligent interviews and screening.
            </p>
            

          </div>

          {/* Links columns */}
          <div>
            <h4 className="text-jacarta-700 font-semibold mb-4">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  {link.onClick ? (
                    <span 
                      onClick={link.onClick}
                      className="text-jacarta-500 text-sm hover:text-accent transition-colors cursor-pointer"
                    >
                      {link.name}
                    </span>
                  ) : (
                    <Link href={link.href}>
                      <a className="text-jacarta-500 text-sm hover:text-accent transition-colors">
                        {link.name}
                      </a>
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-jacarta-700 font-semibold mb-4">Legal</h4>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.name}>
                  <Link href={link.href}>
                    <a className="text-jacarta-500 text-sm hover:text-accent transition-colors">
                      {link.name}
                    </a>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-accent/10">
        <div className="max-w-6xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-jacarta-500 text-sm">
            © {currentYear} SynthiaHire. All rights reserved.
          </p>
          <p className="text-jacarta-500 text-sm">
            Building the future of BFSI recruitment 🚀
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterModern;
